import React from 'react';

import { NavigationWrapper } from 'src/app/navigation-wrapper';
import { WorkspaceNavigation } from 'src/sections/workspace/components/navigation/navigation';

const WorkspaceLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <NavigationWrapper Component={WorkspaceNavigation} mobileHeading="">
      {children}
    </NavigationWrapper>
  );
};
export default WorkspaceLayout;
